<div class="flex flex-col gap-[16px]">
  <div class="flex flex-row justify-between items-baseline">
    <h1 mat-dialog-title class="app-ellipsis">{{ room | value2: 'name' }}</h1>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <app-src-heating-panel
      *ngIf="manager === 'src-temperature-schedule-manager'"
      [roomId]="installationService.selectedRoomId$ | async"
    ></app-src-heating-panel>

    <app-src-other-room-heating-panel
      *ngIf="manager === 'src-other-room-temperature-schedule-manager'"
      [otherRoomId]="installationService.selectedOtherRoomId$ | async"
    ></app-src-other-room-heating-panel>
  </mat-dialog-content>
</div>
